// extracted by mini-css-extract-plugin
module.exports = {"header":"AssociatePOS_header__2Ihhd"};